module.exports = __webpack_public_path__ + "static/img/香港SR.35eb58e3.jpg";